<template>
  <div class="sidebar bg-base-color min-h-screen overflow-x-auto w-[110px] transition-[opacity,transform] md:opacity-100 md:translate-x-0 opacity-0 -translate-x-[110px]">
    <div class="sidebar-wrapper">
      <NavList/>
    </div>
  </div>
</template>

<script>

import {mapActions} from "vuex";
import NavList from "@/components/layout/NavList.vue";

export default {
  name: "Sidebar",
  components: {NavList},
  data() {
    return {
    }
  },
  methods: {
    ...mapActions(["initMenus"])
  },
  mounted() {
    this.initMenus()
  }
}

</script>
